export enum CountPeriodWorkerCountAction {
    Unknown = -1,
    Counted = 0,
    Uncounted = 1
}

export default interface CountPeriodWorkerCountEventResponse {
    id: string;
    countPeriodId: string;
    workerId: string;
    action: CountPeriodWorkerCountAction | keyof typeof CountPeriodWorkerCountAction;
    updatedBy: string;
    updatedByName: string;
    updatedOn: string;
    // The debt that was added (positive) or removed (negative) from the worker
    // when this count action happened. Undoing a count action reverses it.
    debtDelta: number;
}
